/**
 * Product Status conditional visibility.
 *
 * Hides the "Product Status" variant option selector when "Pre-Order" is not
 * orderable for the currently selected Size/Color combo, and auto-selects the
 * first available non-Pre-Order value (e.g. "Ready Stock") so the form submits
 * a valid variant.
 *
 * Asymmetric rule: hide only when Pre-Order is unavailable for the current
 * combo. When only Pre-Order is available, the selector stays visible so the
 * shopper sees the product is preorder-only.
 *
 * Dependencies: <variant-picker> custom element (variant-picker.js).
 * Activation marker: data-product-status-option on the .option-selector
 *   wrapper for the "Product Status" option (set by variant-picker.liquid).
 * Data source: <script type="application/json" data-all-variants> inside
 *   <variant-picker> with [{id, available, options:[...]}].
 */
(function () {
  var PREORDER_VALUE = 'pre-order';

  function normalize(s) {
    return String(s == null ? '' : s).toLowerCase().trim();
  }

  function readVariants(picker) {
    var el = picker.querySelector('script[type="application/json"][data-all-variants]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectorValue(selector) {
    if (selector.dataset.selectorType === 'dropdown') {
      var opt = selector.querySelector('.custom-select__option[aria-selected="true"]');
      return opt && opt.dataset.value !== '' ? opt.dataset.value : null;
    }
    var input = selector.querySelector('input:checked');
    return input ? input.value : null;
  }

  function matchesOtherDims(variant, selectedValues, statusIndex) {
    for (var i = 0; i < variant.options.length; i += 1) {
      if (i === statusIndex) continue;
      if (selectedValues[i] == null) continue;
      if (variant.options[i] !== selectedValues[i]) return false;
    }
    return true;
  }

  function findPreorderVariant(variants, selectedValues, statusIndex) {
    for (var i = 0; i < variants.length; i += 1) {
      var v = variants[i];
      if (normalize(v.options[statusIndex]) !== PREORDER_VALUE) continue;
      if (!matchesOtherDims(v, selectedValues, statusIndex)) continue;
      return v;
    }
    return null;
  }

  function findFirstAvailableNonPreorderValue(variants, selectedValues, statusIndex) {
    for (var i = 0; i < variants.length; i += 1) {
      var v = variants[i];
      if (!v.available) continue;
      if (normalize(v.options[statusIndex]) === PREORDER_VALUE) continue;
      if (!matchesOtherDims(v, selectedValues, statusIndex)) continue;
      return v.options[statusIndex];
    }
    return null;
  }

  function forceSelect(statusOption, targetValue) {
    if (targetValue == null) return false;
    if (statusOption.dataset.selectorType === 'dropdown') {
      var target = statusOption.querySelector(
        '.custom-select__option[data-value="' + (window.CSS && CSS.escape ? CSS.escape(targetValue) : targetValue) + '"]'
      );
      if (!target) return false;
      if (target.getAttribute('aria-selected') === 'true') return false;
      var customSelect = target.closest('custom-select');
      if (customSelect && typeof customSelect.selectOption === 'function') {
        customSelect.selectOption(target);
        return true;
      }
      return false;
    }
    var inputs = statusOption.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].value === targetValue) {
        if (inputs[i].checked) return false;
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function evaluatePicker(picker) {
    var statusOption = picker.querySelector('[data-product-status-option]');
    if (!statusOption) return;

    var variants = readVariants(picker);
    if (!variants || !variants.length) return;

    var selectors = Array.prototype.slice.call(
      picker.querySelectorAll('.option-selector:not(.option-selector--custom)')
    );
    var statusIndex = selectors.indexOf(statusOption);
    if (statusIndex < 0) return;

    var selectedValues = selectors.map(getSelectorValue);

    var preorderVariant = findPreorderVariant(variants, selectedValues, statusIndex);
    var shouldShow = !!(preorderVariant && preorderVariant.available);

    statusOption.style.display = shouldShow ? '' : 'none';

    if (!shouldShow) {
      var fallbackValue = findFirstAvailableNonPreorderValue(variants, selectedValues, statusIndex);
      forceSelect(statusOption, fallbackValue);
    }
  }

  function evaluateAll(root) {
    var pickers = (root || document).querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i += 1) {
      evaluatePicker(pickers[i]);
    }
  }

  document.addEventListener('on:variant:change', function (evt) {
    var picker = evt.target.closest ? evt.target.closest('variant-picker') : null;
    if (picker) {
      evaluatePicker(picker);
    } else {
      evaluateAll(document);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { evaluateAll(document); });
  } else {
    evaluateAll(document);
  }
})();
